export const Request = {

  url: './',

  async request (url = '', method = 'GET', data = {}, dwr = false) {
    if (dwr) $$.dom.dwr(true);
    let newurl = new URL(this.url + url);
    method = method.toUpperCase();
    let response = await this.fetch(newurl, method, data);
    $$.notification.parse(response.notification);
    if (dwr) $$.dom.dwr(false);
    return response;
  },

  async fetch (url, method, data) {
    try {
      let options = {
        method: method
      }
      if (method === 'GET') {
        Object.keys(data).forEach(key => {
          url.searchParams.append(key, data[key]);
        });
      } else if (method === 'POST' || method === 'DELETE') {
        let formData = new URLSearchParams(new FormData());
        Object.keys(data).forEach(key => {
          if (data[key] !== null) {
            formData.append(key, data[key]);
          } else {
            formData.append(key, '');
          }
        });
        options.body = formData;
      }
      let response = await fetch(
        url.href,
        options
      );
      return response.json();
    } catch (error) {
      console.log(error);
    }
  }

};